export interface Article {
  id: string;
  title: string;
  summary: string;
  date: string;
  readMin: number;
  tag: string;
  image: string;
  content: string[];
}

export const articleList: Article[] = [
  {
    id: "ruken-zhinan",
    title: "泡面番入坑指南：五分钟一口气刷完的快乐",
    summary: "刚接触泡面番不知道从哪看起？这篇指南帮你理清泡面番的种类、观剧姿势和入坑推荐，轻松开启一口气刷完的快乐。",
    date: "2026-08-12",
    readMin: 6,
    tag: "入门指南",
    image: "https://readdy.ai/api/search-image?query=cozy%20anime%20style%20flat%20illustration%20of%20a%20comfortable%20sofa%20with%20bowl%20of%20instant%20noodles%20and%20popcorn%20on%20coffee%20table%20in%20front%20of%20a%20tv%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20youthful%20cheerful%20mood&width=1200&height=675&seq=article-ruken-01&orientation=landscape",
    content: [
      "泡面番，顾名思义就是「泡一碗泡面就能看完一集」的超短番剧，单集时长通常在3到7分钟。它们节奏明快、笑点密集，特别适合忙碌的上班族和学生在碎片时间里放松。",
      "看泡面番最大的好处就是「零负担」。不用记复杂的世界观，不用追几十集的长篇剧情，随手点开一集就能获得完整的快乐，还能一口气连刷好几集，满足感直接拉满。",
      "入坑泡面番，推荐从高口碑的日常搞笑类开始，比如《齐木楠雄的灾难》《碧蓝之海》这类公认的下饭神番。它们笑料密集、不挑观众，几乎没有人会不喜欢。",
      "如果你是第一次接触，建议先选「泡面番」和「三分钟短番」分类下的热门作品，看完之后基本就能明白这类短番的魅力所在，再慢慢拓展到治愈系和冷门宝藏。",
    ],
  },
  {
    id: "top10-rihan",
    title: "2026年最值得看的日常搞笑短番 TOP10",
    summary: "摸鱼党必备！我们整理了2026年口碑最高的十部日常搞笑短番，从沙雕玩梗到萌系治愈一网打尽，随时打开随时快乐。",
    date: "2026-08-06",
    readMin: 8,
    tag: "年度盘点",
    image: "https://readdy.ai/api/search-image?query=colorful%20anime%20style%20flat%20illustration%20of%20assorted%20happy%20chibi%20characters%20laughing%20together%20with%20playful%20bubbles%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20energetic%20youthful%20mood&width=1200&height=675&seq=article-top10-01&orientation=landscape",
    content: [
      "日常搞笑短番一直是泡面番里最受欢迎的品类，它们不需要烧脑的剧情，只要角色够鲜活、笑料够密集，就能轻松抓住观众的心。",
      "2026年的日常搞笑短番延续了「小而精」的趋势：单集更短、节奏更快、梗更多。无论是上班通勤还是午休摸鱼，几分钟就能收获一整天的好心情。",
      "这份榜单综合了口碑、人气和搞笑程度，入选的作品都是经过大量观众验证的下饭良品，可以放心按顺序开刷。",
      "如果你已经看腻了常规套路，榜单后半部分还藏了几部冷门但超有梗的宝藏作品，值得专门留出时间慢慢品。",
    ],
  },
  {
    id: "xiafan-anli",
    title: "下饭番安利：这几部看完还想再吃一顿",
    summary: "吃饭没剧看？这五部下饭番节奏轻快、笑点密集，保证让你的用餐时间快乐加倍，连饭都能多吃一碗。",
    date: "2026-07-28",
    readMin: 5,
    tag: "下饭推荐",
    image: "https://readdy.ai/api/search-image?query=delicious%20anime%20style%20flat%20illustration%20of%20a%20lively%20dining%20table%20with%20hot%20bowl%20of%20ramen%20and%20side%20dishes%2C%20appetizing%20warm%20orange%20and%20yellow%20palette%2C%20clean%20minimal%20background%2C%20cheerful%20cozy%20mood&width=1200&height=675&seq=article-xiafan-01&orientation=landscape",
    content: [
      "「下饭番」是指特别适合在吃饭时看的短番，特点是节奏轻快、不用盯着字幕也能跟得上，笑点还不容易让人消化不良。",
      "一部合格的下饭番，最好满足三个条件：单集够短、剧情够轻松、笑点够密集。只有这样才能在享受美食的同时，收获加倍的快乐。",
      "我们挑选的下饭番涵盖了日常搞笑、萌系治愈和社团沙雕等不同风格，无论你喜欢哪种口味，都能找到合胃口的搭配。",
      "温馨提示：笑点太密的下饭番容易让人笑喷，建议嘴里含着食物时不要看太搞笑的桥段，安全第一，快乐第二。",
    ],
  },
  {
    id: "lengmen-baozang",
    title: "冷门宝藏短番推荐：错过就可惜了",
    summary: "在热门泡面番之外，还藏着不少冷门但质量极高的宝藏短番。这篇盘点带你挖出那些被低估的沧海遗珠。",
    date: "2026-07-15",
    readMin: 7,
    tag: "冷门推荐",
    image: "https://readdy.ai/api/search-image?query=treasure%20chest%20anime%20style%20flat%20illustration%20with%20sparkling%20stars%20and%20cute%20mascot%20character%2C%20mysterious%20teal%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20whimsical%20youthful%20mood&width=1200&height=675&seq=article-lengmen-01&orientation=landscape",
    content: [
      "泡面番的世界里，除了大家熟知的热门作品，还有一批冷门但制作精良、剧情有趣的宝藏短番，它们可能因为宣发不够而被人忽略。",
      "冷门并不等于不好看，很多宝藏短番反而因为大胆的创意和独特的美术风格，比热门作品更能带来惊喜。",
      "挖冷门番剧需要一点耐心，但一旦挖到对胃口的作品，那种「捡到宝」的快乐是追热门番完全比不上的。",
      "这篇盘点的每一部冷门短番我们都亲自看过，质量有保证，希望能帮你在茫茫番海里找到专属的宝藏。",
    ],
  },
];